import React from "react";
import { Modal } from "react-bootstrap";

const DeleteConfirmModal = ({ show, onHide, onConfirm, isDeleting, reportName }) => (
  <Modal show={show} onHide={onHide} centered>
    <Modal.Header closeButton>
      <Modal.Title>Confirm Delete</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      Are you sure you want to delete
      {reportName ? ` "${reportName}"` : " this scheduled report"}?
    </Modal.Body>
    <Modal.Footer>
      <button type="button" className="btn btn-outline-secondary" onClick={onHide} disabled={isDeleting}>
        Cancel
      </button>
      <button type="button" className="btn btn-danger" onClick={onConfirm} disabled={isDeleting}>
        {isDeleting ? "Deleting..." : "Delete"}
      </button>
    </Modal.Footer>
  </Modal>
);

export default DeleteConfirmModal;
